module.exports = __webpack_public_path__ + "img/pr.1deaffaf.svg";